import Swiper from 'swiper';
import 'swiper/css/swiper.min.css';
import $ from 'jquery';
import {
    Frame
} from '@/js/frameAnimation.js'

export const init = (vm) => {
    const width = $(window).width();
    const plane1Text = document.querySelectorAll(".vacancy .plane1-text");
    let canvas1;
    let ctx1;

    let canvas2 = $("#canvas2")[0];
    let ctx2 = canvas2.getContext("2d");

    let plane1img = null;
    let plane2img = null;
    let swiper1 = null;
    let swiper3 = null
    if(width > 600) {
        canvas1 = $("#canvas1")[0];
        ctx1 = canvas1.getContext("2d");
    }
    if (width > 1440) {
        canvas1.width = 1920;
        canvas1.height = 960;
    } else if (width > 600) {
        canvas1.width = 1200;
        canvas1.height = 600;
    }else {
        $('.section1').height($('.section1').height())
    }

    if(width > 600) {        
        plane1img = new Frame(canvas1, ctx1, 134, "first/0", plane1Text);
        plane1img.src(
            function () {
                ctx1.drawImage(plane1img.imgArr[0], 0, 0, canvas1.width, canvas1.height);            
                $("#canvas1").addClass('textfade1');
               
            }
        );
        plane2img = new Frame(canvas2, ctx2, 96, "second/p2-");
        s3swiper("horizontal", 5);
    }else {
        s3swiper("horizontal", 3);
        plane2img = new Frame(canvas2, ctx2, 4, "second-mobile/p2-");
    }
    plane2img.src(
        function () {
            ctx2.drawImage(plane2img.imgArr[0], 0, 0, canvas2.width, canvas2.height);
        }
    );
    let flag0 = true, //初始状态
        flag1 = true,
        flag2 = true,
        flag3 = true;

    let num = 0;
    // 滚轮事件

    document.querySelector(".vacancy").onmousewheel = function (evt) {
        if(width < 600) return
        evt = evt || window.event;
        const flag = (1 / event.wheelDelta < 0);
        if (num < 1) {
            num++;
        }
        if (num >= 1 && flag0 && flag) {
            s1Up(true);
            disable(evt)
        }
        if(!plane1img.scrollAble) {
            disable(evt)
        }
    };
    document.querySelector(".vacancy").addEventListener("DOMMouseScroll", function (evt) {
        if(width < 600) return
        const flag = (1 / (event.detail % 3) > 0);
        if (num < 1) {
            num++;
        }
        if (num >= 1 && flag0 && flag) {
            s1Up(true);
            disable(evt)
        }
        if(!plane1img.scrollAble) {
            disable(evt)
        }
    });
    document.querySelector(".vacancy").ontouchstart = function (evt) {
        let y1 = evt.touches[0].clientY
        document.querySelector(".vacancy").ontouchmove = function(ev) {
            let y2 = ev.touches[0].clientY
            if(y1 < y2) {
                y1 = y2
            }else if( y1 - y2 > 10 && flag0) {
                s1Up(true);
                disable(ev)                
            }
        }
    }

    function disable(evt) {
        evt = evt || window.event;
        if (evt.preventDefault) {
            evt.preventDefault();
            evt.stopPropagation();
            return false;
        }
    }

    function s1Up(flag) {
        if(width > 600) {
            if (flag) {
                $(".section1 .section-text1").addClass("textfadeUp");
                $(".section1 .section-text2").addClass("textfadeUp");
                $(".vacancy .plane-wrap").css("opacity", 1).removeClass("textwrap").addClass("planewrap-down");
                $(".pagination1").addClass("pagination1-active");
                plane1img.w_index = 0;
                plane1img.maxFrame = 132;
                plane1img.flag = true;
                plane1animate();
            } else {
                num = 2;
                $(".section1 .section-text1").removeClass("textfadeUp");
                $(".section1 .section-text2").removeClass("textfadeUp");
                $(".vacancy .plane-wrap").removeClass("planewrap-down");
                $(".vacancy .plane1-text").removeClass("p1text-active");
                $(".pagination1").removeClass("pagination1-active");
                $(".pagination1 .planei").removeClass("planei-active");
                plane1img.pause();
                ctx1.clearRect(0, 0, canvas1.width, canvas1.height);
                ctx1.drawImage(plane1img.imgArr[1], 0, 0, canvas1.width, canvas1.height);
            }
        }else {
            if(flag) {
                flag0 = false
                $(".section1 .section-text1").addClass("textfadeUp");
                $(".section1 .section-text2").addClass("textfadeUp");
                $('.init-img').css({display: 'none'})
                $('.first-img-swiper').css({ opacity: 1, top: '0rem'})
                $(".pagination-mini").addClass("pagination-active");
                if(!swiper1) {
                    firstSwiper()
                }else {
                    swiper1.autoplay.start()
                }               
            }else {
                num = 2
                swiper1.autoplay.stop()
                swiper1.slideTo(1)
                $(".section1 .section-text1").removeClass("textfadeUp");
                $(".section1 .section-text2").removeClass("textfadeUp");
                $('.init-img').css({display: 'block'})
                $('.first-img-swiper').css({opacity: 0, top: '5rem'})
                $(".pagination-mini").removeClass("pagination-active");
            }
            setTimeout(() => {
                $('.gatherers').css({
                    height: 'auto',
                    overflow: 'auto'
                })
            }, 500)
        }
    }

    function plane1animate() {
        if (plane1img.loadimg) {
            let timer1 = setTimeout(() => {
                if (!plane1img.flag) {
                    clearTimeout(timer1);
                } else {
                    clearTimeout(plane1img.stopInterval)
                    plane1img.walk(false);
                    plane1img.flag = false;
                    flag0 = false;
                    num = -1;
                    flag1 = true;
                }
            }, 100);
        }
    }

    const page = $(".gatherers").children(".section");
    let setime=null;
    window.onscroll = function (e) {        
        const scrollTop = $(window).scrollTop();
            if (scrollTop === 0 && !flag0 && num === 2) {
                num = 0; //2表示触发动画
                flag0 = true;
                if(width <= 600) {
                    $('.gatherers').css({
                        height: '100vh',
                        overflow: 'hidden'
                    })
                }
            } 
            if (scrollTop > $(".section1").height() - 60 && flag1 || scrollTop > $(".section1").height() - 60 && width <= 600) {
                flag1 = false;
                s1Up(false);
                if(flag2) {
                    plane2img.walk(true)
                }
                flag2 = false
                
            }
        if (scrollTop + $(".section1").height() > $(".section2").offset().top && scrollTop < $(".section3").offset().top) {
            // console.log("滚动触发动画"+ flag3);
            $(".section2").find(".section-text1").addClass('textfade1');
            $(".section2").find(".section-text2").addClass('textfade2');
        } else {
            // console.log("滚动触发的：" +flag3);
            if (width > 600 && flag3) {
                clearTimeout(setime);
                flag3 = false;
            }
        }
        if (scrollTop > $(".section3").offset().top - $(".section2").height()) {
            
            for (let i = 2; i < page.length; i++) {
                if (scrollTop + $(page[i]).prev().height() > $(page[i]).offset().top) {
                    
                    if (i === 2 && width <= 600) {
                        $(page[i]).find(".section-text1").addClass('textfade3');
                        $(page[i]).find(".section-text2").addClass('textfade4');
                    } else {
                        $(page[i]).find(".section-text1").addClass('textfade1');
                        $(page[i]).find(".section-text2").addClass('textfade2');
                    }
                    if (i === (page.length - 1)) {
                        $(page[i]).find("ul").addClass('textfade3');
                    }
                }
            }
        }
        let h1 =  $(".section1").height(), 
            h2 = $(".section2").height(),
            h3 = $(".section3")[0].offsetHeight, 
            h4 = $(".section4").height(),
            h5 = $(".section5")[0].offsetHeight,
            h6 = $('.parameter')[0].offsetHeight
        if(
            scrollTop > h1 - 40 
            && scrollTop <= h1 + h2 - 40 
           || scrollTop > h1 + h2+ h3 - 40
           && scrollTop < h1 + h2+ h3 + h4 - 40
           || scrollTop >= h1 + h2+ h3 + h4 + h5 - 40
           && scrollTop < h1 + h2+ h3 + h4 + h5 + h6 - 40
            ) {
            vm.setHeaderStyle({headerStyle: 'dark'})
        }else if(scrollTop < h1 - 40 
            || scrollTop > h1 + h2 - 40 
            && scrollTop <= h1 + h2 + h3 - 40
            || scrollTop >= h1 + h2+ h3 + h4 - 40
            && scrollTop < h1 + h2+ h3 + h4 + h5 - 40
            || scrollTop >= h1 + h2+ h3 + h4 + h5 + h6 - 40
            ) {
            vm.setHeaderStyle({headerStyle: 'light'})
        }

    }
    $(".pagination-mini i").on("click", function(e) {
        const index = $(this).index()
        swiper1.slideTo(index % 4 + 1)
    })
    $(".pagination1 i").on("click", function (e) {
        plane1img.pause();
        plane1img.flag = true;
        const index = $(this).index();
        if (!plane1img.flag) {
            plane1img.pause();
            return false;
        }
        if (index === 0) {
            plane1img.maxFrame = 29;
            plane1img.w_index = 10;
            plane1img.walk(true);
            plane1img.flag = false;
        } else if (index === 1) {
            plane1img.maxFrame = 57;
            plane1img.w_index = 30;
            plane1img.walk(true);
            plane1img.flag = false;
        } else if (index === 2) {
            plane1img.maxFrame = 92;
            plane1img.w_index = 58;
            plane1img.walk(true);
            plane1img.flag = false;
        } else if (index === 3) {
            plane1img.maxFrame = 124;
            plane1img.w_index = 93;
            plane1img.walk(true);
            plane1img.flag = false;
        }
    })
    function firstSwiper() {
        swiper1 = new Swiper(".first-img-swiper", {
            loop: true,
            autoplay: {
                delay: 1200
            },
            observer: true,
            speed: 600,
            observeParents: true,
            on: {
                slideChangeTransitionStart: function() {
                    $('.plane-wrap .pagination').find('.planei').removeClass('planei-active')
                    $('.plane-wrap .pagination').find('.planei').eq((this.activeIndex-1) % 4).addClass('planei-active')
                }
            }
        })
    }

    function s3swiper(direction, preview) {
        swiper3 = new Swiper(".s3swiper", {
            direction: direction,
            slidesPerView: preview,
            initialSlide: 1,
            centeredSlides: true,
            loop: true,    
            spaceBetween: 30,
            autoplay: {
                delay: 1200, //1秒切换一次
                disableOnInteraction: false
            },
            observer: true,
            speed: 600,
            observeParents: true,
            observeSlideChildren: true,
            on: {
                slideChangeTransitionStart: function () {                                     
                    const p = $(".s3swiper").find(".module-text").eq(this.activeIndex);
                    this.updateSlidesClasses()
                    p.addClass("toggle").parent().siblings().find(".module-text").removeClass("toggle");
                }
            }
        });
        if (width > 600) {
            $(".nav-menu").children(".tabs").click(function () {
                if ($(this).index() !== 0) {
                    swiper.autoplay.stop();
                } else {
                    swiper.autoplay.start();
                }
            })
        }
    }
    return {
        plane1img,
        plane2img,
        swiper3
    }
}
